export interface GalleryProperty {
  id: string;
  title: string;
  subtitle: string;
  location: string;
  imageUrl: string;
  externalUrl: string;
  tag: string;
  isDemo?: boolean;
}

export const galleryProperties: GalleryProperty[] = [
  {
    id: "the-obsidian-villa",
    title: "The Obsidian Villa",
    subtitle: "Architektonisches Meisterwerk",
    location: "Schweiz",
    imageUrl: "https://public.readdy.ai/ai/img_res/ce1a5e8a721a6f69df51283cebe0caaa.jpg",
    externalUrl: "https://the-obsidian-villa.ch/",
    tag: "Privatlage",
    isDemo: false,
  },
  {
    id: "villa-zurichsee",
    title: "Villa am Zürichsee",
    subtitle: "Seeblick-Residenz",
    location: "Küsnacht, Zürich",
    imageUrl: "https://readdy.ai/api/search-image?query=ultra-luxury-modern-villa-lake-zurich-switzerland-stunning-architecture-floor-to-ceiling-windows-infinity-pool-panoramic-alpine-view-golden-hour-photography-editorial-architectural-excellence&width=800&height=600&seq=spdb001&orientation=landscape",
    externalUrl: "/kontakt",
    tag: "Seeblick",
    isDemo: true,
  },
  {
    id: "penthouse-zurich-west",
    title: "Penthouse Zürich West",
    subtitle: "Urbane Exklusivität",
    location: "Zürich, Kreis 5",
    imageUrl: "https://readdy.ai/api/search-image?query=ultra-modern-penthouse-zurich-city-rooftop-terrace-panoramic-skyline-minimalist-interior-white-marble-floor-designer-furniture-evening-light-luxury-real-estate-switzerland&width=800&height=600&seq=spdb002&orientation=landscape",
    externalUrl: "/kontakt",
    tag: "Stadtlage",
    isDemo: true,
  },
  {
    id: "anwesen-zug",
    title: "Anwesen Zug",
    subtitle: "Herrschaftlicher Landsitz",
    location: "Zug, Zentralschweiz",
    imageUrl: "https://readdy.ai/api/search-image?query=exclusive-swiss-estate-zug-traditional-architecture-large-garden-park-surrounded-by-trees-stone-facade-high-end-luxury-property-switzerland-bright-sunny-editorial-photo&width=800&height=600&seq=spdb003&orientation=landscape",
    externalUrl: "/kontakt",
    tag: "Privatlage",
    isDemo: true,
  },
  {
    id: "chalet-gstaad",
    title: "Chalet Gstaad",
    subtitle: "Alpine Eleganz",
    location: "Gstaad, Berner Oberland",
    imageUrl: "https://readdy.ai/api/search-image?query=luxury-alpine-chalet-gstaad-switzerland-traditional-wood-stone-architecture-snowy-mountain-backdrop-interior-fireplace-warm-wood-premium-ski-resort-real-estate-editorial&width=800&height=600&seq=spdb004&orientation=landscape",
    externalUrl: "/kontakt",
    tag: "Alpenlage",
    isDemo: false,
  },
  {
    id: "villa-ascona",
    title: "Villa Ascona",
    subtitle: "Mediterranes Refugium",
    location: "Ascona, Tessin",
    imageUrl: "https://readdy.ai/api/search-image?query=mediterranean-luxury-villa-ascona-lake-maggiore-ticino-switzerland-terraced-garden-palm-trees-blue-water-white-stone-architecture-golden-light-sunset-premium-property&width=800&height=600&seq=spdb005&orientation=landscape",
    externalUrl: "/kontakt",
    tag: "Seelage",
    isDemo: false,
  },
  {
    id: "residence-genf",
    title: "Résidence Genève",
    subtitle: "Diplomatische Adresse",
    location: "Genf, Cologny",
    imageUrl: "https://readdy.ai/api/search-image?query=prestigious-neoclassical-residence-geneva-cologny-switzerland-white-facade-formal-garden-lake-view-high-end-diplomat-luxury-estate-photography-architectural-beauty&width=800&height=600&seq=spdb006&orientation=landscape",
    externalUrl: "/kontakt",
    tag: "Exklusivlage",
    isDemo: false,
  },
];

export const featuredProperties: GalleryProperty[] = galleryProperties.slice(0, 3);
